import { getOrDelete } from './glosbe-dictionary-api-helper';
export function getLanguageData(code) {
    return getOrDelete({ endpoint: 'language', params: { code } });
}
